import Cleave from 'cleave.js';
import 'cleave.js/dist/addons/cleave-phone.se';

const Register = function() {
    const __constructor = () => {
        document.querySelectorAll('.format-phone').forEach(function(field) {
            new Cleave(field, {
                phone: true,
                phoneRegionCode: 'SE',
            });
        });

        document.querySelectorAll('.format-zip').forEach(function(field) {
            new Cleave(field, {
                numericOnly: true,
                blocks: [3, 2],
                delimiters: [' ']
            });
        });

        document.querySelectorAll('.format-org-nr').forEach(function(field) {
            new Cleave(field, {
                numericOnly: true,
                blocks: [6, 4],
                delimiters: ['-']
            });
        });
    }

    __constructor();
}

export default Register;
